import React from 'react';

export default {
  continueButtonLabel: 'Continuar',
  goBackButtonLabel: 'Voltar',
  search: {
    title: 'Encontre o nome de domínio ideal para o seu negócio',
    inputLabel: 'Digite seu domínio aqui (ex:meunegocio.com)',
    offer: (
      <>
        <strong>Oferta Especial:</strong>
        {' '}
        Contrate um domínio
        {' '}
        <strong>.com</strong>
        {' '}
        ou
        {' '}
        <strong>.com.br</strong>
        {' '}
        e leve
        {' '}
        <strong className="freeDomain">.online</strong>
        {' '}
        e
        {' '}
        <strong className="freeDomain">.store</strong>
        {' '}
        grátis no primeiro ano!
      </>
    ),
    footerText: 'Selecione um domínio para continuar',
    error: {
      title: 'Não foi possível buscar o domínio.',
      description: 'Por favor, tente novamente em instantes.',
    },
  },
  list: {
    domainDescription: {
      br: (
        <>
          {'O '}
          <strong>mais popular</strong>
          {' no Brasil'}
        </>
      ),
      com: (
        <>
          {'O '}
          <strong>mais buscado</strong>
          {' no mundo'}
        </>
      ),
      net: (
        <>
          {'Altamente '}
          <strong>confiável</strong>
        </>
      ),
      org: (
        <>
          {'Sua organização '}
          <strong>em destaque</strong>
        </>
      ),
      store: (
        <>
          {'Reserve para sua '}
          <strong>loja virtual</strong>
        </>
      ),
      online: (
        <>
          {'Moderno e '}
          <strong>flexível</strong>
        </>
      ),
      tech: (
        <>
          {'Moderno e '}
          <strong>direto ao ponto</strong>
        </>
      ),
    },
    optionsCycle: {
      one: 1,
      two: 2,
      three: 3,
      year: number => `Ano${number > 1 ? 's' : ''}`,
    },
    radixLabel: 'GRÁTIS POR 1 ANO',
    thenLabel: ({ value, cycle }) => {
      const rules = {
        1: 'ano',
        2: 'bienal',
        3: 'trienal',
      };
      return `Após: ${value} / ${rules[cycle]}`;
    },
    domainInUse: 'Domínio em uso',
    domainInUseList: {
      title: 'O que você pode fazer:',
      infoList: [
        ' • Buscar por outro nome de domínio',
        ' • Escolher outras sugestões com o mesmo nome',
      ],
    },
    protectID: {
      title: 'Sem proteção, seus dados ficarão visíveis para qualquer um. Evite golpes e spam!',
      description: ({ price, cycle }) => {
        const rules = {
          one: 'ano',
          two: 'bienal',
          three: 'trienal',
        };

        return (
          <>
            {'Ative o ID Protect e mantenha suas informações invisíveis por '}
            <strong>
              {'apenas '}
              {price}
              {`${`/${rules[cycle]}`}`}
            </strong>
            . Renovação automática.
          </>
        );
      },
    },
  },
};
